import { Suspense } from "react";

import { BarLoading } from "@/components/Loading/BarLoading";
import { PageErrorBoundary } from "@/layout/ErrorBoundary/PageErrorBoundary";
import { ChannelQueriesContextProvider } from "@/pages/channels/pages/detail/channelQueriesContext";
import { EmailDetailPageInternal } from "@/pages/channels/pages/detail/email/EmailDetailPage";

export const EmailDetailPage: React.FC = () => {
  return (
    <PageErrorBoundary>
      <Suspense fallback={<BarLoading />}>
        <ChannelQueriesContextProvider>
          <EmailDetailPageInternal />
        </ChannelQueriesContextProvider>
      </Suspense>
    </PageErrorBoundary>
  );
};
